/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateSalesforceVerificationKeyInput = {|
  useSandbox?: ?boolean,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type createSalesforceVerificationKeyMutationVariables = {|
  input: CreateSalesforceVerificationKeyInput
|};
export type createSalesforceVerificationKeyMutationResponse = {|
  +createSalesforceVerificationKey: ?{|
    +key: ?string
  |}
|};
export type createSalesforceVerificationKeyMutation = {|
  variables: createSalesforceVerificationKeyMutationVariables,
  response: createSalesforceVerificationKeyMutationResponse,
|};
*/


/*
mutation createSalesforceVerificationKeyMutation(
  $input: CreateSalesforceVerificationKeyInput!
) {
  createSalesforceVerificationKey(input: $input) {
    key
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateSalesforceVerificationKeyInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateSalesforceVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createSalesforceVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createSalesforceVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createSalesforceVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createSalesforceVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation createSalesforceVerificationKeyMutation(\n  $input: CreateSalesforceVerificationKeyInput!\n) {\n  createSalesforceVerificationKey(input: $input) {\n    key\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7600fbbba8895f113be24f3555d4e645';

module.exports = node;
